module.exports = "<div class=\"js-header-region layout__tab-layout__header-region\"></div> <div class=\"js-panel-container layout__tab-layout__panel-container\"></div>";


//////////////////
// WEBPACK FOOTER
// ../src/layout/tabLayout/tabLayout.hbs
// module id = 705
// module chunks = 0